import IntroPageView from 'src/pages/IntroPage/view'
import useLocalStorage from 'src/hooks/useLocalStorage.hook'
import React, { useEffect } from 'react'
import useCustomCookies from 'src/hooks/useCustomCookies.hook'
import { logoutQueryOption, useCustomMutation } from 'src/hooks/react-query/useCustomMutation.hook'

const IntroPage = () => {
  const [, , removeRecentHistory] = useLocalStorage<string[]>('recent_search_history', [])
  const { removeAllCookies } = useCustomCookies()

  const { mutateAsync: logoutMutate } = useCustomMutation<unknown, unknown>(logoutQueryOption())

  useEffect(() => {
    logoutMutate({}).finally(() => {
      removeRecentHistory()
      removeAllCookies()
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <IntroPageView />
}
export default IntroPage
